import DownloadSVG from '../../assets/svg/download.svg';
export default DownloadSVG;
